// extracted by mini-css-extract-plugin
export default {"wbsLevelWrapper":"WbsLevelFilter_wbsLevelWrapper__GanIS","title":"WbsLevelFilter_title__QFBxS","sliderWrapper":"WbsLevelFilter_sliderWrapper__ZRzxs"};